import { memo, useCallback, useMemo } from "react";

import { FeatureIslandContainer } from "@/components/features/_layouts";

import { ReferenceArticles, SettingsSiteControllerHeader } from "../_shared";
import { REFERENCE_ARTICLES } from "./constants";
import { SettingsSiteControllerNotSelectedMain } from "./main";

import type { SiteControllerSettingBaseFormModel } from "../../../model/base/type";
import type { SiteControllerSettingBaseFormModelMethodsType } from "../../../model/base/use-case/use-create-model/methods";
import type { SiteControllerSettingBaseFormModelOnSetViewModelType } from "../../../model/base/use-case/use-create-model/use-create-model";

type Props = {
	viewModel: SiteControllerSettingBaseFormModel["ViewModel"]; //
	onSetViewModel: SiteControllerSettingBaseFormModelOnSetViewModelType;

	siteControllerSettingBaseFormModelMethodsType: SiteControllerSettingBaseFormModelMethodsType;
};

export const SettingsSiteControllerNotSelected = memo(
	({ viewModel, siteControllerSettingBaseFormModelMethodsType }: Props) => {
		const onUpdate = useCallback(async () => {
			await Promise.resolve();
		}, []);

		const isValid = useMemo(
			() => viewModel.isDirty && !viewModel.hasError,
			[viewModel.hasError, viewModel.isDirty],
		);

		return (
			<FeatureIslandContainer>
				<SettingsSiteControllerHeader onUpdate={onUpdate} isValid={isValid} />

				<ReferenceArticles articles={REFERENCE_ARTICLES} />

				<SettingsSiteControllerNotSelectedMain
					hotelID={viewModel.hotelID}
					viewModel={viewModel}
					siteControllerSettingBaseFormModelMethodsType={siteControllerSettingBaseFormModelMethodsType}
				/>
			</FeatureIslandContainer>
		);
	},
);

SettingsSiteControllerNotSelected.displayName = "SettingsSiteControllerNotSelected";
